import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { getCardDate } from '~/utils/card-utils/card-utils';

import styles from './StreamCard.module.scss';

export enum CardType {
  CompanyCatalyst,
  MarketCatalyst,
  MarketSummary,
  Scenario,
  EarningsPreview,
  EarningsRecap,
}

export interface StreamCardProps {
  className?: string;
  headerContent: ReactNode;
  cardTitle: ReactNode;
  description: ReactNode;
  leftNode?: ReactNode;
  onClick?: () => void;
  date?: Date;
  variant?: 'default' | 'secondary';
}

export const StreamCard = ({
  className,
  headerContent,
  cardTitle,
  description,
  leftNode,
  onClick,
  date,
  variant = 'default',
}: StreamCardProps) => {
  const cardDate = date ?? new Date();
  const isDefault = variant === 'default';

  return (
    <div
      className={clsx(
        styles.root,
        isDefault && styles.defaultVariant,
        className
      )}
      onClick={onClick}
    >
      <div className={styles.flexWrapper}>
        {leftNode}
        <div className={styles.content}>
          <div className={styles.headerWrapper}>{headerContent}</div>
          {cardTitle}
          <div className={styles.footerWrapper}>
            <div className={styles.description}>{description}</div>
            <span className={styles.dateLabel}>{getCardDate(cardDate)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
